import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MoreTestimonials } from './MoreTestimonials';
const plan = {
  name: '📘 CORÉEN EXPRESS™',
  ideal: 'Toute personne qui souhaite comprendre le coréen depuis zéro, sans avoir étudié de langues auparavant',
  was: '54€',
  now: '19€',
  features: ['6 Tomes Complets (120+ pages)', 'Hangeul depuis zéro, expliqué visuellement', 'Vraies expressions K-Drama & K-Pop', 'Routine de 60 minutes avec progrès visible', '5 Bonus Gratuits inclus', 'Garantie de satisfaction 7 jours', 'Accès à vie & mises à jour gratuites'],
  cta: 'Obtenir Coréen Express'
};
const trust = [{
  icon: LockIcon,
  label: 'Paiement 100% Sécurisé'
}, {
  icon: ZapIcon,
  label: 'Accès Instantané'
}, {
  icon: CreditCardIcon,
  label: 'Carte de Crédit / Débit'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Tarifs" className="bg-radial-glow w-full overflow-x-hidden" data-id="element-144" data-mp="3vynh8bvjpr9c">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" data-id="element-145" data-mp="4ruh7bchny6e">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center rounded-3xl border border-grape/30 bg-white px-6 pb-7 pt-10 text-center shadow-[0_24px_60px_-28px_rgba(193,18,31,0.4)]" data-id="element-146" data-mp="9sia62ka2p39">
          <h3 className="font-display text-lg font-black text-plum" data-id="element-147" data-mp="3n525l1eogq45">{plan.name}</h3>
          <p className="mt-2 text-sm text-plum/60" data-id="element-148" data-mp="3rz6brig4cu46">
            <span className="font-semibold text-plum/80" data-id="element-149" data-mp="2uizjto6r84l6">Idéal pour :</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-150" data-mp="2zh13obc087xp">
            <span className="text-base font-medium text-plum/40 line-through" style={{
            fontSize: "20px"
          }} data-id="element-151" data-mp="2zfznjsg4sv94">{plan.was}</span>
            <div className="text-grape-shine font-display text-4xl font-black" style={{
            fontSize: "64px",
            paddingBottom: "26px",
            fontFamily: "Cinzel, serif",
            paddingTop: "20px"
          }} data-id="element-152" data-mp="2res40ddut913">{plan.now}</div>
            <p className="mt-1 text-xs font-semibold text-grape" data-id="element-153" data-mp="318qxyp3rxmhy">
              Paiement unique · Accès illimité
            </p>
            <p className="mt-1 text-[11px] font-medium text-plum/50" data-id="element-154" data-mp="28hqssatpicop">
              Le paiement sera traité dans votre devise locale.
            </p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-155" data-mp="23l0ftwd77x7i">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-156" data-mp="2ihhr6nle1bu2">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-157" data-mp="2dfil35y9k0tf" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-158" data-mp="3ow8vz2dmtgtd">
            <CTAButton size="md" data-id="element-159" data-mp="3ovqunrc44cel">{plan.cta}</CTAButton>
          </div>

          <p className="mt-3 text-[11px] font-semibold text-plum/50" data-id="element-160" data-mp="9c8qimer0zp">
            Vous économisez 35€ (65% de réduction)
          </p>
          

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/55" data-id="element-161" data-mp="57dtd7zhf8da">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-162" data-mp="3rirhvn807hmz">
                <Icon className="h-4 w-4 text-grape" data-id="element-163" data-mp="j1eq5w6vilb0" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <MoreTestimonials data-id="element-164" data-mp="a8jjcy1rchj4" />

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-grape/20 bg-white/80 p-5 text-left" data-id="element-165" data-mp="a9cu0a3u7r6j">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-grape" data-id="element-166" data-mp="e8bzpwxe7rz1" />
          <p className="text-[15px] leading-relaxed text-plum/75" data-id="element-167" data-mp="11yxuimidzfr3">
            <span className="font-display font-bold text-plum" data-id="element-168" data-mp="16qzdssdz26qm">
              🛡️ Garantie de satisfaction 7 jours.
            </span>{' '}
            Si dans les 7 premiers jours vous pensez que l'ebook ne correspond pas à ce dont vous
            avez besoin ou ne vous donne pas l'impulsion que vous recherchiez, demandez votre
            remboursement et nous vous restituons 100% de votre argent. Nous voulons que vous
            appreniez en toute tranquillité, sans risque.
          </p>
        </div>
      </div>
    </section>;
}